import { useTranslation } from 'react-i18next';

import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
// import { Timeline } from 'primereact/timeline';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PropTypes from 'prop-types';
import { TIMEZONE_VN } from 'constant';
import { toCamelCaseString } from 'utils/func';

export default function ViewHistoryProposal({ data, visible, setVisible }) {
  const { t } = useTranslation();

  const formatStatus = (value) => {
    const statusColorMapping = {
      create: 'var(--green-500)',
      update: 'var(--orange-500)',
      submit: 'var(--blue-500)',
      approved: 'var(--purple-500)',
      rejected: 'var(--red-500)',
      new: 'var(--blue-500)',
    };

    return (
      <Tag
        style={{ background: statusColorMapping[toCamelCaseString(value.actionType)] }}
        value={t(`proposal.status.${toCamelCaseString(value.actionType)}`)}
        rounded
      />
    );
  };

  const formatUpdate = (value) => {
    const statusColorMapping = {
      true: 'var(--green-500)',
      false: 'var(--red-500)',
    };

    const statusTextMapping = {
      true: t('proposalList.viewHistory.update.updated'),
      false: t('proposalList.viewHistory.update.pending'),
    };

    if (value?.isRevised === undefined || value?.isRevised === null) {
      return null;
    }

    return (
      <Tag
        style={{ background: statusColorMapping[value.isRevised] }}
        value={statusTextMapping[value.isRevised]}
        rounded
      />
    );
  };

  const formatCreatedAt = (value) => {
    const datetime = new Date(value.createdAt);
    datetime.setHours(datetime.getHours() + 7);
    const formattedDatetime = datetime.toLocaleString('vi-VN', {
      timeZone: TIMEZONE_VN,
    });
    return <small className="text-color-secondary">{formattedDatetime}</small>;
  };

  return (
    <Dialog
      header={<p className="text-blue-500">{t('proposalList.viewHistory.title')}</p>}
      visible={visible}
      position="center"
      style={{ width: '900px' }}
      onHide={() => setVisible(false)}
      draggable={false}
    >
      <DataTable
        value={data}
        className="p-datatable-gridlines header-table"
        responsiveLayout="scroll"
        scrollable
        scrollHeight="450px"
        showGridlines
        emptyMessage={t('proposal.history.empty')}
      >
        <Column
          header={t('proposal.history.no')}
          // eslint-disable-next-line react/no-unstable-nested-components
          body={(_, { rowIndex }) => <span>{rowIndex + 1}</span>}
          style={{ width: '50px', textAlign: 'center' }}
        />
        <Column
          field="fullname"
          header={t('proposal.history.owner')}
          style={{ minWidth: '12rem', textAlign: 'left' }}
        />
        <Column
          field="note"
          header={t('proposal.history.note')}
          style={{ minWidth: '20rem', textAlign: 'left' }}
          // eslint-disable-next-line react/no-unstable-nested-components
          body={(value) => (
            <span style={{ whiteSpace: 'pre-wrap' }} className="text-color-secondary">
              {value.note}
            </span>
          )}
        />
        <Column
          field="createdAt"
          header={t('proposal.history.time')}
          body={formatCreatedAt}
          style={{ minWidth: '5rem', textAlign: 'left' }}
        />
        <Column
          field="actionType"
          header={t('proposal.history.status')}
          body={formatStatus}
          style={{ minWidth: '9rem', textAlign: 'center' }}
        />
        <Column
          header={t('proposal.history.update')}
          body={formatUpdate}
          style={{ minWidth: '9rem', textAlign: 'center' }}
        />
      </DataTable>
    </Dialog>
  );
}

ViewHistoryProposal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};
